import de from "language-icons/icons/de.svg"
//import en from "language-icons/icons/en.svg"
import es from "language-icons/icons/es.svg"
import it from "language-icons/icons/it.svg"
import pl from "language-icons/icons/pl.svg"
import nl from "language-icons/icons/nl.svg"

export const icons = {
  de, /* en, */ es, it, pl, nl
}

export const ids = [
  'de', /* 'en', */ 'es', 'it', 'pl', 'nl'
]




// WEBPACK FOOTER //
// ./src/misc/langs.js